import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import Countdown from "react-countdown";
import ReactCardFlip from "react-card-flip";
import {
  Card,
  Col,
  Button,
  Spinner,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";

//
import Telegram from "../../../assets/img/telegram-1.webp";
import {
  generateTelegramCode,
  getUser,
} from "../../../redux/features/user/actions";

const telegramURL = process.env.REACT_APP_TELEGRAM_URL;
const telegramName = process.env.REACT_APP_TELEGRAM_NAME;
const qrCodeSrc = `https://api.qrserver.com/v1/create-qr-code/?data=${telegramURL}&size=220x220&margin=0`;

function SocialAccounts({ user, getUser, modal = false }) {
  const [loading, setLoading] = useState(false);
  //
  const [isFlipped, setIsFlipped] = useState(false);
  //
  const [telegramCode, setTelegramCode] = useState("");
  //
  const [generateCode, setGenerateCode] = useState(false);
  const [timerKey, setTimerKey] = useState(0);

  /**
   * Check Connection
   */
  const checkConnection = async () => {
    // start loading
    setLoading(true);

    // request
    await getUser().then((res) => {
      if (res) {
        let telegram_id = res.payload.telegram_id;

        if (telegram_id) {
          setIsFlipped(false);
        }
      }
    });

    // stop loading
    setLoading(false);
  };

  /**
   * Generate New Code
   */
  const generate_new_code = () => {
    // start loading
    setLoading(true);

    // request
    generateTelegramCode().then((res) => {
      if (res) {
        setTelegramCode(res);

        setIsFlipped(true);

        setLoading(false);

        setTimerKey(timerKey + 1);

        setGenerateCode(false);
      } else {
        setLoading(false);
      }
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="qr-code-tooltip" {...props}>
      <img src={qrCodeSrc} className="telegram-qrcode" />
      <h5 className="text-white mt-1">Scan me!</h5>
    </Tooltip>
  );

  // Renderer callback with condition
  const renderer = ({ minutes, seconds }) => {
    return (
      <p className="text-info">
        New Code Generated In {minutes}:{seconds}
      </p>
    );
  };

  const timerComplete = () => {
    setGenerateCode(true);
  };

  return (
    <Card className={`social-account h-100 ${!modal ? "bordered" : ""}`}>
      <Card.Body className={modal ? 'p-0' : ''}>
        {!modal && (
          <div className="title">
            <h5>Connect to Telegram Account</h5>
            <p className="subject">
              Connect to telegram account to get signals
            </p>
          </div>
        )}

        <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
          <div className="content">
            <img src={Telegram} alt="telegram" />

            <h5 className="text-center">
              Telegram {!user.telegram_id && "Not"} Connected
            </h5>

            <Button variant="info" onClick={() => generate_new_code()}>
              {user.telegram_id ? "Change Account" : "Connect"}
              {loading && (
                <div className="spinner-holder">
                  <Spinner animation="border" variant="white" size="sm" />
                </div>
              )}
            </Button>
          </div>

          <div className="content">
            <i
              className="las la-times-circle pointer"
              onClick={() => setIsFlipped(false)}
            ></i>
            <p>
              To connect and recive signals in telegram, please send
              <span className="fw-bolder"> "{telegramCode}" </span>
              to our telegram bot
              <a href={telegramURL} target="_blank" className="text-info">
                {" "}
                {telegramName}{" "}
              </a>
              we will automatically confirm you after sending the code
            </p>

            <div className="d-flex align-items-center">
              <i
                className="las la-globe mr-1 pointer"
                onClick={() => window.open(telegramURL)}
              ></i>
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <i className="las la-qrcode"></i>
              </OverlayTrigger>
            </div>

            <div>
              {generateCode ? (
                <p
                  className="text-info pointer"
                  onClick={() => generate_new_code()}
                >
                  Generate New Code
                </p>
              ) : (
                <Countdown
                  date={Date.now() + 180000}
                  renderer={renderer}
                  zeroPadTime={2}
                  onComplete={timerComplete}
                />
              )}
            </div>

            {!user.telegram_id && (
              <Button variant="info" onClick={() => checkConnection()}>
                Check Connection
                {loading && (
                  <div className="spinner-holder">
                    <Spinner animation="border" variant="white" size="sm" />
                  </div>
                )}
              </Button>
            )}
          </div>
        </ReactCardFlip>
      </Card.Body>
    </Card>
  );
}

SocialAccounts.propTypes = {
  user: PropTypes.object.isRequired,
  getUser: PropTypes.func.isRequired,
  modal: PropTypes.bool,
};

const mapDispatchToProps = {
  getUser,
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(SocialAccounts);
